import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import StarRatingOwnerReviewContext, {
  useHasOwnerReviews
} from '~/context/vdp/StarRatingOwnerReviewContext';
import {
  useGetSpinnerData,
  useGetVehicleDetails
} from '~/context/vdp/VehicleContext';
import useGetPoseOEMData from '~/hooks/vdp/selectors/useGetPoseOEMData';
import useGetWhyBuyDataLoaded from '~/hooks/vdp/selectors/useGetWhyBuyDataLoaded';
import useWhyBuyData from '~/hooks/vdp/selectors/useWhyBuyData';
import useShowWhyBuyContent from '~/hooks/vdp/useShowWhyBuyContent';

export default function useSendContentAvailability(): void {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    hasOwnerReviews: { isLoaded: hasOwnerReviewsLoaded }
  } = useContext(StarRatingOwnerReviewContext);
  const { isLoaded: hasWhyBuyLoaded } = useGetWhyBuyDataLoaded();
  const { type: whyBuyType, bulletPoints = [] } = useWhyBuyData();
  const hasOwnerReviews = useHasOwnerReviews();
  const showWhyBuyContent = useShowWhyBuyContent();
  const { showPoseOEMData } = useGetPoseOEMData();
  const {
    brochureUrl,
    isOEMFirstVehicle = false,
    windowStickerUrl
  } = useGetVehicleDetails();
  const { imperfections = [] } = useGetSpinnerData();

  const imperfectionCount = imperfections.length;

  useEffectOnce(
    () => {
      trackEvent('content-availability', {
        hasBrochure: Boolean(brochureUrl),
        hasPoseOemData: showPoseOEMData,
        hasOwnerReviews,
        hasWindowSticker: Boolean(windowStickerUrl),
        imperfectionCount,
        isOEMFirstVehicle,
        hasWhyBuy: showWhyBuyContent,
        whyBuyCount: bulletPoints?.length,
        whyBuyType
      });
    },
    [
      brochureUrl,
      bulletPoints?.length,
      hasOwnerReviews,
      imperfectionCount,
      isOEMFirstVehicle,
      showPoseOEMData,
      showWhyBuyContent,
      trackEvent,
      whyBuyType,
      windowStickerUrl
    ],
    hasOwnerReviewsLoaded && hasWhyBuyLoaded
  );
}
